import styled from 'styled-components';
import { AllieItem } from '../../../../components';

export const QuickButtonStyled = styled.div`
  width: 100%;
`;

export const AllieItemStyled = styled(AllieItem)`
  --padding-start: 0;
  --inner-padding-end: 0px;
  width: 100%;
  min-height: 50px;
`;

export const QuickButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-xs);
`;

export const BubbleStyled = styled.div<{ isSelected?: boolean, type?: 'full' | 'default' }>`
  border-radius: var(--allie-radius-xl);
  background-color: var(--allie-color-white);
  color: var(--allie-color-neutral-70);
  border: 1px solid var(--allie-color-neutral-30);
  padding: var(--allie-spacing-lg) var(--allie-spacing-xl);
  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: var(--allie-color-primary-60);
    color: var(--allie-color-white);
  `}
  width: ${({ type }) => (type === 'full' ? '100%' : 'auto')};
`;
